import React from "react";
import { Circle, CheckCircle2, Trash2 } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function ChecklistItems({ tabItems, customItems, checkedMap, activeTab, onToggle, onRemove }) {
  return (
    <div className="space-y-1.5 mb-5">
      {/* Base items */}
      {tabItems.map((item) => {
        const isChecked = !!checkedMap[item.id];
        return (
          <button
            key={item.id}
            onClick={() => onToggle(activeTab, item.id)}
            className={`w-full flex items-start gap-3 text-left px-4 py-3 border transition-all active:scale-[0.99] select-none ${
              isChecked
                ? "bg-[#F5F5F2] border-[#DCD4C6] opacity-70"
                : "bg-white border-[#DCD4C6] hover:border-[#C17F59]/50"
            }`}
            style={{ borderRadius: "3px" }}
            data-testid={`item-${item.id}`}
          >
            <span className="flex-shrink-0 mt-0.5">
              {isChecked ? (
                <CheckCircle2 size={18} strokeWidth={2} color="#C17F59" />
              ) : (
                <Circle size={18} strokeWidth={1.5} color="#C8C0B8" />
              )}
            </span>
            <span className="flex-1 min-w-0">
              <span
                className={`block text-sm ${isChecked ? "line-through text-[#9A8F86]" : "text-[#2B2623]"}`}
                style={LORA}
              >
                {item.text}
              </span>
              {item.note && !isChecked && (
                <span className="block text-xs text-[#8B5E34] italic mt-1 leading-relaxed" style={LORA}>
                  {item.note}
                </span>
              )}
            </span>
          </button>
        );
      })}

      {/* Custom items */}
      {customItems.map((item) => {
        const isChecked = !!checkedMap[item.id];
        return (
          <div
            key={item.id}
            className={`flex items-center gap-3 px-4 py-3 border transition-all ${
              isChecked
                ? "bg-[#F5F5F2] border-[#DCD4C6] opacity-70"
                : "bg-white border-[#C17F59]/30 hover:border-[#C17F59]/60"
            }`}
            style={{ borderRadius: "3px" }}
            data-testid={`custom-item-${item.id}`}
          >
            <button
              onClick={() => onToggle(activeTab, item.id)}
              className="flex-shrink-0"
              data-testid={`toggle-custom-${item.id}`}
            >
              {isChecked ? (
                <CheckCircle2 size={18} strokeWidth={2} color="#C17F59" />
              ) : (
                <Circle size={18} strokeWidth={1.5} color="#C8C0B8" />
              )}
            </button>
            <span
              className={`flex-1 text-sm ${isChecked ? "line-through text-[#9A8F86]" : "text-[#2B2623]"}`}
              style={LORA}
            >
              {item.text}
            </span>
            <button
              onClick={() => onRemove(activeTab, item.id)}
              className="flex-shrink-0 text-[#C8C0B8] hover:text-red-400 transition-colors p-0.5"
              data-testid={`remove-item-${item.id}`}
            >
              <Trash2 size={13} strokeWidth={1.5} />
            </button>
          </div>
        );
      })}

      {tabItems.length === 0 && customItems.length === 0 && (
        <p className="text-center text-sm text-[#9A8F86] italic py-6" style={LORA}>
          Aucun élément dans cet onglet.
        </p>
      )}
    </div>
  );
}
